export const resolveHeight = (height) => {
  if (height === undefined || height === null || height === '') return 'auto';
  if (typeof height === 'number') return `${height}px`;
  return height;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/ScrollBox/utils/scrollHelpers.js